/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    ADD_ITEM(state, item) {
        state.products.unshift(item)
    },

    SET_REGIONS(state, products) {
        state.institutions = products;
    },

    SET_CONTACTS(state, contacts) {
        state.contacts = [];
        for (let i = 0; i < contacts.length; i++) {
            let contact = {
                id: contacts[i].id,
                next: contacts[i].upcomingFollowup,
                status: contacts[i].hasSymptoms ? "სიმპტომებით" : "უსიმპტომოდ",
                institutions: contacts[i].institutions,
                medication: contacts[i].treatment,
                name: contacts[i].firstName + " " + contacts[i].lastName,
            };
            state.contacts.push(contact)
        }
    },

    SET_INDEX_PATIENTS(state, patients) {
        state.index_patients = [];
        for (let i = 0; i < patients.length; i++) {
            let contact = {
                id: patients[i].id,
                code: patients[i].code,
                contacts: patients[i].contactCount,
                date: patients[i].createDate,
                institutions: patients[i].institutions,
                name: patients[i].firstName + " " + patients[i].lastName,
            };
            state.index_patients.push(contact)
        }
    },

    SET_INDEX_PATIENT_INFO(state, patient_info) {
        state.index_patient_info = patient_info;
    },

    SET_PATIENT_INFO(state, patient_info) {
        state.patient_info = patient_info;
    },

    SET_PATIENT_TREATMENTS(state, treatments) {
        state.patient_treatments = treatments;
    },

    SET_PATIENT_RESEARCHES(state, researches) {
        state.patient_researches["tb"] = researches.find(el => el.type === "TB") ? researches.find(el => el.type === "TB") : {};
        state.patient_researches["tbi"] = researches.find(el => el.type === "TBI") ? researches.find(el => el.type === "TBI") : {};
    },

    SET_INDEX_PATIENT_CURRENT_CASES(state, current_cases) {
        state.index_patient_current_cases = current_cases;
    },

    SET_INDEX_PATIENT_CONTACTS(state, contacts) {

        state.index_patient_contacts = [];
        for (let i = 0; i < contacts.length; i++) {
            let contact = {
                id: contacts[i].id,
                type: contacts[i].relationType,
                status: contacts[i].status,
                treatment: contacts[i].treatment,
                currentPatientType: contacts[i].currentPatientType,
                name: contacts[i].firstName + " " + contacts[i].lastName,
            };
            state.index_patient_contacts.push(contact)
        }
    },

    SET_RISK_GROUPS(state, patients) {
        state.risk_groups = [];
        for (let i = 0; i < patients.length; i++) {
            let patient = {
                id: patients[i].id,
                next: patients[i].upcomingFollowUpDate,
                status: patients[i].status,
                risk_factors: patients[i].riskFactors,
                institutions: patients[i].institutions,
                medication: patients[i].treatment,
                treatmentCompleted: patients[i].treatmentCompleted,
                name: patients[i].firstName + " " + patients[i].lastName,
            };
            state.risk_groups.push(patient)
        }
    },

    SET_INDEX_META(state, response) {
        state.index_meta = response;
    },

    SET_CONTACTS_META(state, response) {
        state.contacts_meta = response;
    },

    SET_RISK_GROUPS_META(state, response) {
        state.risk_groups_meta = response;
    },

    SET_FOLLOWUPS(state, response) {
        state.followups = response ? response : [];
    },

    SET_CASES(state, response) {
        state.cases = response;
    },

}
